import React, { useState, useRef } from "react";
import "../../styles.css";
import SingleCalendar from "../SingleCalendar";
import { BCMSDate } from "@bcm-dev/bcms-vite"; 

export default function DateSelectView(props) {
  const ref = useRef();
  const { setDate, onChange } = props;
  const [isActive, setActive] = useState(false);  // Stores if view is rendered
  // Controllers accessible from custom hooK;
  let showTop = false;
  if(ref.current){  
    showTop = document.getElementById("root").getBoundingClientRect().bottom < ref.current.getBoundingClientRect().bottom+461    
  }
  const controllers = {
    "open": () =>   setActive(true),       // Opens view
    "close": () => setActive(false),      // closes view 
    "set": (value) => onChange(value),   // Sets value of container
    "get": () =>setDate,       // Gets value of container
    "toggle": () => setActive(!isActive), // Toggle view
    "allowFuture": props.allowFuture ?? true,
    "allowPast": props.allowPast ?? false,
    "maxFutureDate": props.maxFutureDate ?? false
  }
  //let disabled = (date) => BCMSDate.init(date).setToFirst().isAfter(BCMSDate.init().setToFirst());

  let leftDisabled = date => !controllers.allowPast ? BCMSDate.init(date).setToFirst().isAfter(BCMSDate.init().setToFirst()) : true;

  let rightDisabled = date => !controllers.allowFuture ? BCMSDate.init(date).setToFirst().isBefore(BCMSDate.init().setToFirst()) : true;

  const use = props.use instanceof Function
    ? props.use
    : (controllers, children) => React.cloneElement(children, { controllers });
   
    
  return (
    <div className="date-select" ref={ref}>
      {/*The view of the date select when closed*/}
      {use(controllers, props.children)}
      {/*Show Single Date Select if screen is bigger than mobile threshold active*/}
      {isActive && <div className={"date-select-calendar"+ (showTop ?" show-top":"")} ><SingleCalendar controllers={controllers} {...props} setDate={setDate} onChange={onChange} inputDate={props.inputDate}  leftDisabled={leftDisabled} rightDisabled={rightDisabled}/></div>}
       {/*Transparent overlay to dismiss date select if clicked outside*/}
      {isActive && <div className="date-select-overlay" onClick={controllers.close}></div>}
    </div>
  );
}

